export default __webpack_public_path__ + "static/media/playarmshield.5392caa9.png";